import { FC } from "react";
import HistoryHeader from "./history-header";
import HistoryForm from "./history-form";
import HistoryResult from "./history-result";

const History: FC = () => {
  return (
    <div>
      <HistoryHeader />
      <HistoryForm />
      <HistoryResult />
    </div>
  );
};

export default History;
